import * as React from 'react';
import { Alert } from 'antd';

interface OrchestrationValidationAlertProps {
    errors: string[];
}

/**
 * Component that displays orchestration validation errors for Orchestrated prompt templates.
 * Shows the rules that must be followed and lists current validation issues.
 */
const OrchestrationValidationAlert: React.FC<OrchestrationValidationAlertProps> = ({ errors }) => {
    // Don't render if there are no errors
    if (errors.length === 0) {
        return null;
    }

    return (
        <Alert
            message="Template Structure Validation Failed"
            description={
                <div>
                    <p>
                        <strong>Orchestrated templates must follow these rules:</strong>
                    </p>
                    <ul style={{ marginBottom: 8 }}>
                        <li>
                            <strong>Pre-Processing:</strong> Optional (0 or 1 block allowed)
                        </li>
                        <li>
                            <strong>Processing:</strong> Required (at least 1 block)
                        </li>
                        <li>
                            <strong>Post-Processing:</strong> Required (exactly 1 block)
                        </li>
                    </ul>
                    <p>
                        <strong>Current issues:</strong>
                    </p>
                    <ul style={{ marginBottom: 0 }}>
                        {errors.map((error, index) => (
                            <li key={index}>{error}</li>
                        ))}
                    </ul>
                </div>
            }
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
        />
    );
};

export default OrchestrationValidationAlert;
